'use strict';
angular.module('cvsApp').factory('getSpecialtyOrderQuestionsModel',['commonModel',function(CM) {	
	
	var getSpecialtyOrderQuestionsModel = function(){

		var self = this;

		var apiResponse = {};
		
		this.setResponse = function(data){
			CM.setResponse(data);			
		}	

		this.getResponse = function(data){
			apiResponse = CM.getResponse();
			self.apiResponse = apiResponse;
			return self;		
		}	

		this.showView = function(){
			if(apiResponse.isViewError){	
				return !apiResponse.isViewError;
			}
			return true;
		}

		this.getError = function(){
			if(apiResponse.showError){	
				return apiResponse.showError;
			}
			return "";
		}

		
		this.getContent = function(){
			if(!apiResponse.showError){
				return apiResponse.questionTags.questionTag;
			}	
		}

		this.getContentFromModel = function(){
			var questionTags = {"questionTags":
									{"questionTag":[
										{"questionId":"1",
										"questionOrder":"1",
										"question":"Since your last refill, have you experienced any new allergies?",
										"UIElement":"YesNoRadio",
										"followupQuestions":""
									},{
										"questionId":"2",
										"questionOrder":"2",
										"question":"Are there any changes to your insurance",
										"UIElement":"YesNoRadio",
										"followupQuestions":{
												"followupQuestion":[
												{"subQuestionId":"2.1",
												"subQuestion":"New insurance company name",
												"required":"true",
												"UIElement":"text",
												"options":""
												},{
													"subQuestionId":"2.2",
													"subQuestion":"Phone number",
													"required":"true",
													"UIElement":"textPhoneNumber",
													"options":""
												},{
													"subQuestionId":"2.3",
													"subQuestion":"Effective date",
													"required":"true","UIElement":"textDate",
													"options":""
												},{
													"subQuestionId":"2.4",
													"subQuestion":"Cardholder name",
													"required":"true",
													"UIElement":"text",
													"options":""
												},{
													"subQuestionId":"2.5",
													"subQuestion":"Cardholder date of birth",
													"required":"true",
													"UIElement":"textDate",
													"options":""
												},{
													"subQuestionId":"2.6",
													"subQuestion":"Cardholder date of birth",
													"required":"true",
													"UIElement":"textDate",
													"options":""
												},{
													"subQuestionId":"2.7",
													"subQuestion":"Relationship to the cardholder",
													"required":"true",
													"UIElement":"multipleOptionRadio",
													"options":{
														"option":["Self","Spouse","Caregiver","Sibling"]
														}
												},{
													"subQuestionId":"2.8",
													"subQuestion":"Employer name",
													"required":"false",
													"UIElement":"text",
													"options":""
												},{
													"subQuestionId":"2.9",
													"subQuestion":"ID number",
													"required":"false",
													"UIElement":"text",
													"options":""
												},{
													"subQuestionId":"2.10",
													"subQuestion":"Group number(GRP)",
													"required":"false",
													"UIElement":"text",
													"options":""
												},{
													"subQuestionId":"2.11",
													"subQuestion":"BIN(RxBIN)",
													"required":"false",
													"UIElement":"text",
													"options":""
												},{
													"subQuestionId":"2.12",
													"subQuestion":"PCN(RxPCN)",
													"required":"false",
													"UIElement":"text",
													"options":""
												}]
											}
										},{
											"questionId":"3",
											"questionOrder":"3",
											"question":"Since your last refill, have you changed the dosage of your medication(s)?",
											"UIElement":"YesNoRadio",
											"followupQuestions":{
												"followupQuestion":[
												{
													"subQuestionId":"3.1",

													"subQuestion":"New dosage",
													"required":"true",
													"UIElement":"text",
													"options":""
												},{
													"subQuestionId":"3.2",
													"subQuestion":"New frequency",
													"required":"true",
													"UIElement":"text",
													"options":""
												}]
											}
										},{
											"questionId":"4",
											"questionOrder":"4",
											"question":"How many doses of your medication(s) do you have left?",
											"UIElement":"YesNoRadio",
											"followupQuestions":{
												"followupQuestion":[{
													"subQuestionId":"4.1",
													"subQuestion":"Number of doses left",
													"required":"true",
													"UIElement":"text",
													"options":""
												},{
													"subQuestionId":"4.2",
													"subQuestion":"When will you take your next dose?",
													"required":"true",
													"UIElement":"textDate",
													"options":""}]
												}
										},{
											"questionId":"5",
											"questionOrder":"5",
											"question":"Has your prescribing physician information changed?",
											"UIElement":"YesNoRadio",
											"followupQuestions":{
												"followupQuestion":[{
													"subQuestionId":"5.1",
													"subQuestion":"Physician name",
													"required":"true",
													"UIElement":"text",
													"options":""
												},{
													"subQuestionId":"5.2",
													"subQuestion":"Phone number",
													"required":"true",
													"UIElement":"textPhoneNumber",
													"options":""}]
												}
											},{"questionId":"6",
											"questionOrder":"6",
											"question":"Are there any issues regarding administering this medication",
											"UIElement":"YesNoRadio",
											"followupQuestions":""
										}]
									}
								}
              return questionTags.questionTags.questionTag;
		}
	
	}
	
	return new getSpecialtyOrderQuestionsModel();
}]);